<template>
    <div class="card card-custom card-stretch gutter-b shadow-sm" :class="`bg-${type}`">
        <!--begin::Body-->
        <div class="card-body">
            <div class="d-flex align-items-center mb-2">
                <div>
                    <span :class="[icon, `text-${ type.split('-').length > 1 ? type.split('-')[1] : type }`]" class="fa-fw font-size-h3 mb-0"></span>
                </div>
                <div class="flex-fill pl-3">
                    <span class="font-size-h6 font-weight-bold text-dark-50 mb-0">
                        {{ label }}
                    </span>
                </div>
            </div>
            <div class="card-title font-weight-bolder font-size-h2 mb-0">
                {{ number }}
            </div>
        </div>
        <!--end::Body-->
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default() {
                return 'light-primary'
            }
        },
        icon: {
            type: String,
            default() {
                return 'far fa-chart-bar'
            }
        },
        number: [String, Number],
        label: String
    }
}
</script>